@if (taxReturn?.id) {
<div>
  <header>
    @if (taxReturn.snapshot) {
    <app-snapshot-banner
      [snapshot]="taxReturn.snapshot"
      [status]="taxReturn.fullStatus"
    >
    </app-snapshot-banner>
    } @if (!taxReturn.snapshot && taxReturn.mandatoryIncompleteClientRulesCount)
    {
    <app-message-banner
      type="WARNING"
      [hidden]="!!taxReturn.snapshot"
      [message]="getClientRulesWarning()"
    >
    </app-message-banner>
    }
    <h3>{{ taxReturnAlias }}</h3>
    <div id="tax-filters" class="ui bottom aligned grid">
      <div class="row">
        <div class="ten wide column">
          <label>{{ "taxReturns.include" | transloco }}</label>
          <div id="notifications-filter">
            <select
              #multiSelectDropdown
              class="ui fluid normal multi-select dropdown"
              multiple=""
              [(ngModel)]="iconsFilter"
            >
              <option value="all">{{ "taxReturns.all" | transloco }}</option>
              <option value="warnings">{{
                "taxReturns.warnings" | transloco
              }}</option>
              <option value="flags">{{
                "taxReturns.flags" | transloco
              }}</option>
              <option value="comments">{{
                "taxReturns.comments" | transloco
              }}</option>
              <option value="notes">{{
                "taxReturns.notes" | transloco
              }}</option>
              <option value="documents">{{
                "taxReturns.documents" | transloco
              }}</option>
            </select>
          </div>
        </div>
        <div id="keyword-filter" class="six wide column">
          <div class="ui left icon fluid input">
            <i class="search icon"></i>
            <input
              type="text"
              [(ngModel)]="taxSearch"
              placeholder="Search {{ taxReturnAlias }}..."
            />
          </div>
        </div>
      </div>
    </div>
  </header>
  <div id="categories-container">
    @for (category of taxReturn?.categories | isGlobal:globalFilter; track
    category) {
    <div class="category-container">
      @for (subCategory of category?.subcategories | keyWord:['name',
      'code']:taxSearch | categoryMetaCount:iconsFilter; track subCategory; let
      index = $index) {
      <div
        [routerLink]="['subcategories', subCategory.id]"
        [queryParams]="
          taxReturn.snapshotId != null
            ? { snapshot: taxReturn.snapshotId }
            : null
        "
        class="subcategory-container"
        id="s{{ subCategory.id }}"
      >
        <div
          id="{{ category?.name | lowercase | cleanElementSelector }}"
          class="fragment-container"
        ></div>
        @if (index === 0) {
        <div class="category-header" style="padding-left:1rem">
          {{ category?.name }}
        </div>
        }
        <div class="subcategory-header no-select">
          <div>
            <!--<span class="category-code">{{subCategory?.code}}</span>-->
            <span class="category-name">{{ subCategory?.name }}</span>
            <span class="item-count"
              >{{ subCategory?.subCategoryGroupsCount }}
              {{
                subCategory?.subCategoryGroupsCount === 1 ? "item" : "items"
              }}</span
            >
          </div>
          <div class="notifications-icons">
            @if (subCategory?.documentCount) {
            <span class="notification-icon documents-highlighted">
              <span class="count">{{ subCategory?.documentCount }}</span>
            </span>
            } @if (getWarningsCount(subCategory)) {
            <span class="notification-icon warnings-highlighted">
              <span class="count">{{ getWarningsCount(subCategory) }}</span>
            </span>
            } @if (subCategory?.warningAppeaseCount &&
            !subCategory?.warningCount) {
            <span class="notification-icon warnings">
              <span class="count">{{ subCategory?.warningAppeaseCount }}</span>
            </span>
            } @if (subCategory?.flagCount) {
            <span class="notification-icon flags-highlighted">
              <span class="count">{{ subCategory?.flagCount }}</span>
            </span>
            } @if (subCategory?.flagsAppeaseCount && !subCategory?.flagsCount) {
            <span class="notification-icon flags">
              <span class="count">{{ subCategory?.flagsAppeaseCount }}</span>
            </span>
            } @if (subCategory?.commentCount) {
            <span class="notification-icon comments-highlighted">
              <span class="count">{{ subCategory?.commentCount }}</span>
            </span>
            } @if (subCategory?.notesCount) {
            <span class="notification-icon notes-highlighted">
              <span class="count">{{ subCategory?.notesCount }}</span>
            </span>
            }
          </div>
        </div>
        @if (subCategory?.questions.length > 0) {
        <div class="questions-container">
          @for (question of subCategory?.questions; track question) {
          <div>
            @if (question?.topLevel) {
            <div class="question-container">
              <div class="question-label">
                @if (showQuestionId) {
                <span>{{ question?.id }}.</span>
                }
                {{ question?.question }}
              </div>
              <div class="question-answer">
                {{
                  question
                    | answerDisplay
                      : computeTopLevelAnswer(question, question.answers)
                }}
              </div>
            </div>
            }
          </div>
          }
          <div class="clear"></div>
        </div>
        }
      </div>
      }
    </div>
    }
  </div>
</div>
} @if (!taxReturn?.id) {
<div class="ui active inverted dimmer">
  <div class="ui large text loader">{{ "taxReturns.loading" | transloco }}</div>
</div>
}
